import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Lot } from './';

@Model()
export default class LongTermRate extends ApplicationRecord {
  static jsonapiType = 'long-term-rates';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Rate',
        value: 'rate',
      },
    ];
  }

  static scopeFactory() {
    return LongTermRate.includes([]);
  }

  @Attr() rate: string | null;

  @HasOne() lot: Lot;

  get formattedRate() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(this.rate));
  }
}
